/** Strategem 56 (Viral Echo) — 3 green plus signs on the healed general */

export const VIRAL_ECHO_PLUS_STAGGER_MS = 95;
export const VIRAL_ECHO_PLUS_COUNT = 3;
export const VIRAL_ECHO_HEAL_FX_TOTAL_MS =
  VIRAL_ECHO_PLUS_STAGGER_MS * (VIRAL_ECHO_PLUS_COUNT - 1) + 720;

/**
 * Three spots inside the profile circle: polar offsets from the avatar rect center.
 * angleDeg: 0 = right, 90 = down (screen coords); radiusFrac scales distance from center (× min(w,h)/2).
 */
export const VIRAL_ECHO_PLUS_IN_CIRCLE = [
  { angleDeg: -88, radiusFrac: 0.34 },
  { angleDeg: 152, radiusFrac: 0.36 },
  { angleDeg: 32, radiusFrac: 0.36 },
];
